// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__cuwWB","productName":"Table_productName__3NirW"};